export default "__VITE_ASSET__BlzAVB6k__"